import autobind from 'core-decorators/lib/autobind';

import decorate from 'widget/utils/decorate';
import { notForPreview } from 'widget/utils/not-for-preview';

import { openFullScreenOverlay } from 'shared/utils/open-overlay';

import InFrameActions from './in-frame';


@decorate(InFrameActions)
export default class InOverlayActionCallbacks extends React.Component {
  static propTypes = {
    children: React.PropTypes.element.isRequired,
    selectVideo: React.PropTypes.func.isRequired,
    playVideo: React.PropTypes.func.isRequired,
    channelId: React.PropTypes.string,
    videoId: React.PropTypes.string,
  };

  @autobind
  @notForPreview
  showVideoAtOverlay() {
    const { channelId, videoId } = this.props;
    openFullScreenOverlay(`#/channel/${channelId}/video/${videoId}`);
  }

  @autobind
  @notForPreview
  playVideoAtOverlay() {
    const { channelId, videoId } = this.props;
    openFullScreenOverlay(`#/channel/${channelId}/video/${videoId}/play`);
  }

  render() {
    const inFrameActions = _.omit(this.props, this.propTypes);

    return React.cloneElement(this.props.children, {
      ...inFrameActions,
      onClick: this.showVideoAtOverlay,
      onPlayRequest: this.playVideoAtOverlay,
      onPlayWithoutPreviewRequest: this.showVideoAtOverlay,
    });
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/actions/overlay-action-callbacks/in-overlay.js